import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { generatePdfSaga } from "./sagas/generatePdfSaga";
import { deleteGeneratedPdfSaga } from "./sagas/deleteGeneratedPdfSaga";
import { signPdfSaga } from "./sagas/signPdfSaga";
import { downloadSignedPdfSaga } from "./sagas/downloadSignedPdfSaga";

const modul16pdfGenerierenModule = (): Module => ({
	id: "modul16pdfGenerierenModule",
	sagas: () => [generatePdfSaga, deleteGeneratedPdfSaga, signPdfSaga, downloadSignedPdfSaga]
});

export default modul16pdfGenerierenModule;
